export enum SpecialCharacters {
  DOT = 'dot',
  SPACE = 'space',
  NO_SPACE = 'noSpace',
  SOME = 'some',
  ADDRESS = 'address',
  NUMBER_ONLY = 'numberOnly',
  ALPHABET_ONLY = 'alphabetOnly',
  LAT_LONG = 'latLong',
  ALPHABET_NUMBER = 'alphabetNumber',
  ALPHABET_NUMBER_NO_SPACE = 'alphabetNumberNoSpace',
  SPECIAL_WITH_PERIOD = 'specialExceptPeriod',
  NO_RESTRICTIONS = 'noRestrictions',
  COMMA = 'comma',
  EMAIL = 'emailPattern',
  CURRENCY_USD = 'currencyUSD',
  TIME = 'time',
  DOT_SPACE_ALLOW = 'dotSpace',
  ALPHA_SPACE_ONLY = 'alphaSpace',
  ALPHA_SPACE_DASH = 'alphaSpaceDash',
  CANADIAN_POSTAL = 'canadianPostal',
  LINKED_SITES = 'linkedsites',
  DECIMAL_NUMBER = 'decimalNumber',
  PICKUP_POPUP = 'pickupPopup',
  PICKUP_ADDRESS = 'pickupAddress',
  ALPHABET_BASIC_PUNCT = 'alphabetBasic',
}

export const REGEX_PATTERNS: Record<string, RegExp> = {
  alphabet: /^[a-zA-Z]+$/,
  alphanumeric: /^[a-zA-Z\d]+$/,
  numeric: /^\d+$/,
  alphabetWithSpace: /^[a-zA-Z\s]+$/,
  alphabetWithSpaceAndDash: /^[a-zA-Z-\s]+$/,
  alphanumericWithDash: /^[a-zA-Z0-9-]+$/,
  emailSafe: /^[a-zA-Z0-9@._-]+$/,
  pickupPopup: /^[A-Za-z0-9\,\#\:\&\/\-\_\.\"\'\ ]+$/,
  pickupAddress: /^[A-Za-z0-9\-. ]+$/,
  latlong: /^[\-]?[\d]+\.[\d]+$/,
  alphabetBasicPunct: /^[A-Za-z0-9\,\.\'\ ]+$/,
} as const;
